import React from "react";

export function coverageState(covered, total) {
  if (!total) return null;
  if (covered <= 0) return "none";
  if (covered < total) return "partial";
  return "full";
}

export default function CoverageBar({ covered, total, compact = false, label }) {
  if (total === 0) return null;
  const state = coverageState(covered, total);
  const pct = total ? Math.round((covered / total) * 100) : 0;
  const className = `vs-cov${compact ? " vs-cov--compact" : ""}${state ? ` vs-cov--${state}` : ""}`;
  return (
    <span
      className={className}
      {...(compact
        ? { "aria-hidden": true }
        : {
            role: "progressbar",
            "aria-valuemin": 0,
            "aria-valuemax": total,
            "aria-valuenow": covered,
            "aria-label": label ?? `Закрыто ${covered} из ${total}`,
          })}
    >
      <span className="vs-cov__track">
        <span className="vs-cov__fill" style={{ width: `${pct}%` }} />
      </span>
      {!compact && (
        <span className="vs-cov__text">
          <b>{covered}</b> / {total} закрыто
        </span>
      )}
    </span>
  );
}
